import React, { FC } from 'react';
import { useSelector } from 'react-redux';

// Shared UI Library Components
import { CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './personal-data.scss';

// Components
import { PhotoProfile } from '../photo-profile/photo-profile';
import { PersonalLink } from '../personal-link/personal-link';
import { GeneralData } from '../general-data/general-data';
import { AboutProfile } from '../about-profile/about-profile';
import { ChangeProfileStatus } from '../../change-profile-status/change-profile-status';
import { SpecialtySpecialisations } from '../specialty-specialisations/specialty-specialisations';

// Store entities
import { getCurrentCounsellorState } from '../../../../store/current-counsellor/current-counsellor.selectors';
import { getUserState } from '../../../../store/user/user.selectors';

// Models
import { TCounsellorCompanyStatus } from '../../../../types/counsellor.types';

type TPersonalDataProps = {};

export const PersonalData: FC<TPersonalDataProps> = (
  {}: TPersonalDataProps
) => {

  const { counsellor } = useSelector(getCurrentCounsellorState);
  const { user } = useSelector(getUserState);
  const getStatusByFieldValue = (worker_company_status: TCounsellorCompanyStatus): string => {
    if (worker_company_status === 'active') {
      return 'Active';
    }
    if (worker_company_status === 'deactivated') {
      return 'Inactive';
    }
    if (worker_company_status === 'blocked') {
      return 'Blocked';
    }
    return 'Archived';
  }

  return (
    <div className="personal-data">
      <div className="personal-data--header">
        <div className="header-title">
          Personal Data
        </div>
        <div className="header-action">
          <div className={ `header-action--status header-action--status-${ counsellor?.worker_company_status }` }>
            { getStatusByFieldValue(counsellor?.worker_company_status as TCounsellorCompanyStatus) }
          </div>
          <div className="header-action--menu-trigger">
            { counsellor && <ChangeProfileStatus
              stripeConnected={ !!user?.is_stripe_connected }
              canActivate={ !!counsellor?.rates_enabled_count && counsellor?.is_signup_completed }
              worker_company_status={ counsellor?.worker_company_status }
              counsellor_id={ counsellor?.id }
            /> }
          </div>
        </div>
      </div>

      { (!counsellor?.rates_enabled_count || !counsellor?.is_signup_completed) &&
        <div className="personal-data--notifier">
          <div className="notifier-icon">
            <CustomIcon size={ 'size-xl-32' } name={ EIconName.Info }/>
          </div>
          <div className="notifier-text">
            <div className="notifier-text--item">
              To activate the Consultant:
            </div>
            { !counsellor?.is_signup_completed && <div className="notifier-text--item has-point">
              Ensure that the Consultant has accepted the invitation (sent to the provided email) and completed the
              onboarding process.
            </div> }
            { !counsellor?.rates_enabled_count && <div className="notifier-text--item has-point">
              Set up the Consultant's rates.
            </div> }
          </div>
        </div> }

      { (!!counsellor?.rates_enabled_count && !!counsellor?.is_signup_completed && counsellor?.worker_company_status === 'deactivated') &&
        <div className="personal-data--notifier notifier-success">
          <div className="notifier-icon">
            <CustomIcon size={ 'size-xl-32' } name={ EIconName.Info }/>
          </div>
          <div className="notifier-text">
            <div className="notifier-text--item">
              You can activate this Consultant.
            </div>
          </div>
        </div> }

      { counsellor && <div className="personal-data--body">
        <div className="body-item body-item--photo">
          <PhotoProfile workerPhoto={ counsellor.photo } worker_id={ counsellor.id }
                        isCurrentAdmin={ counsellor.id === user?.id }/>
        </div>

        <div className="body-item split-items">
          <PersonalLink
            personalLinkNotEditable={ `${ process.env.REACT_APP_USER_APP_URL }/${ counsellor.company_code }/` }
            personalLinkEditable={ counsellor.personal_link }
            worker_id={ counsellor.id }
            inactiveCounsellor={ counsellor.worker_company_status !== 'active' }
          />
          <GeneralData counsellor={ counsellor } isCurrentAdmin={ user?.id === counsellor?.id }/>
        </div>

        <div className="body-item full-width">
          <SpecialtySpecialisations counsellor={ counsellor }/>
        </div>

        <div className="body-item split-items">
          <AboutProfile about={ counsellor.about } worker_id={ counsellor.id }/>

          {/*<PreviewProfile/> TODO in next release */ }
        </div>

        {/*<div className="body-item split-items"> TODO in next release */ }
        {/*  <EducationProfile/>*/ }
        {/*  <ExperienceProfile/>*/ }
        {/*</div>*/ }
      </div> }
    </div>
  );
}
